import { NonDriveTimeType } from '@xpo-ltl/sdk-linehaulpayform';
import * as _ from 'lodash';

enum ActivityNames {
  HOOK = 'HOOK',
  DROP = 'DROP',
}

export class ActivityUtils {
  /**
   * Returns true if the activity requires equipment (trailers/dollys), else false.
   * @param activity Activity to check
   */
  public static requiresEquipment(nonDriveTime: NonDriveTimeType): boolean {
    const actvtyName = _.get(nonDriveTime, 'actvtyName', '').toUpperCase();
    return actvtyName === ActivityNames.HOOK || actvtyName === ActivityNames.DROP;
  }
}
